import { z } from 'zod';

import { IdSchema, IsoDateSchema } from './common.js';

export const BillingEntitlementSchema = z.enum(['trialing', 'active', 'grace', 'locked']);
export type BillingEntitlement = z.infer<typeof BillingEntitlementSchema>;

export const BillingProviderStatusSchema = z.enum([
  'created',
  'authenticated',
  'active',
  'pending',
  'halted',
  'paused',
  'cancelled',
  'completed',
  'expired',
]);
export type BillingProviderStatus = z.infer<typeof BillingProviderStatusSchema>;

export const BillingSubscriptionSchema = z.object({
  id: IdSchema,
  providerStatus: BillingProviderStatusSchema,
  currentPeriodEnd: IsoDateSchema.nullable(),
  accessUntil: IsoDateSchema.nullable(),
  graceEndsAt: IsoDateSchema.nullable(),
  cancelAtCycleEnd: z.boolean(),
});

export const BillingStatusResponseSchema = z.object({
  billingEnabled: z.boolean(),
  entitlement: BillingEntitlementSchema,
  trialStartedAt: IsoDateSchema.nullable(),
  trialEndsAt: IsoDateSchema.nullable(),
  trialDays: z.number().int().positive(),
  daysRemaining: z.number().int().nonnegative(),
  subscription: BillingSubscriptionSchema.nullable(),
  product: z.object({
    name: z.string(),
    amountPaise: z.number().int().nonnegative(),
    currency: z.literal('INR'),
    interval: z.literal('monthly'),
  }),
});
export type BillingStatusResponse = z.infer<typeof BillingStatusResponseSchema>;

export const CreateBillingCheckoutResponseSchema = z.object({
  keyId: z.string().min(1),
  subscriptionId: z.string().min(1),
  productName: z.string().min(1),
  description: z.string().min(1),
  prefill: z.object({
    name: z.string(),
    email: z.string().email(),
  }),
});
export type CreateBillingCheckoutResponse = z.infer<typeof CreateBillingCheckoutResponseSchema>;

export const ConfirmBillingCheckoutSchema = z.object({
  razorpayPaymentId: z.string().min(1).max(100),
  razorpaySubscriptionId: z.string().min(1).max(100),
  razorpaySignature: z.string().regex(/^[a-f0-9]{64}$/i),
});
export type ConfirmBillingCheckoutInput = z.infer<typeof ConfirmBillingCheckoutSchema>;

export const CancelBillingSubscriptionSchema = z.object({
  atCycleEnd: z.boolean().default(true),
});
export type CancelBillingSubscriptionInput = z.infer<typeof CancelBillingSubscriptionSchema>;
